var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-item_free",
      style: { "padding-left": _vm.paddingLeft }
    },
    [
      _vm.formNode.children == 0
        ? _c("div", { staticClass: "enpty-free" }, [
            _vm._v("请从左侧拖拽或点击任意添加组件")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "draggable",
        {
          staticClass: "form-grid_draggable",
          attrs: {
            value: _vm.formNode.children,
            options: {
              group: { name: "free_wrap", put: _vm.onPut },
              handle: ".drag-bar",
              ghostClass: "free-draggable-status_ghost"
            }
          },
          on: {
            input: function(v) {
              return (_vm.formNode.children = v.filter(function(i) {
                return i
              }))
            },
            add: function(e) {
              return _vm.handleAddFormItem(e, _vm.formNode.children)
            }
          },
          model: {
            value: _vm.formNode.children,
            callback: function($$v) {
              _vm.$set(_vm.formNode, "children", $$v)
            },
            expression: "formNode.children"
          }
        },
        _vm._l(_vm.formNode.children, function(el) {
          return _c("form-item-template", {
            key: el.id,
            class: el.type,
            attrs: { formNode: el, formParent: _vm.formNode.children }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7471a7f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7471a7f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form_item/FormItemFree.vue
// module id = null
// module chunks = 